import { parseBulkDiaryIdsSearch } from "@/features/patients/features/overview/table/bulk/bulkSearch";
import { createFileRoute, redirect } from "@tanstack/react-router";

/** Legacy `/patients/bulk/events?eventType=injection` → `/patients/bulk/events/injection`. */
export const Route = createFileRoute("/_app/patients/bulk/events/")({
    validateSearch: (search: Record<string, unknown>) => parseBulkDiaryIdsSearch(search),
    beforeLoad: ({ search }) => {
        const eventType = search.eventType;
        const { eventType: _eventType, ...rest } = search;

        if (eventType) {
            throw redirect({
                to: "/patients/bulk/events/$eventType",
                params: { eventType },
                search: () => rest,
                replace: true,
            });
        }

        throw redirect({
            to: "/patients",
            search: () => rest,
            replace: true,
        });
    },
});
